module.exports = __webpack_public_path__ + "static/media/broken-bone.d1c4182c.svg";